// 习题类型转换
export const EXERCISE_TYPE_KEY = {
  0: 'NOEXERCISETYPE',
  1: 'SINGLE_CHOICE',
  2: 'MULTIPLE_CHOICE',
  3: 'COMPLETION',
  4: 'JUDGE',
  5: 'ANSWER_QUESTIONS',
  6: 'COMPREHENSIVE',
}

// 习题类型枚举
export const EXERCISE_TYPE = {
  NOEXERCISETYPE: 'NOEXERCISETYPE',
  SINGLE_CHOICE: 'SINGLE_CHOICE',
  MULTIPLE_CHOICE: 'MULTIPLE_CHOICE',
  COMPLETION: 'COMPLETION',
  JUDGE: 'JUDGE',
  ANSWER_QUESTIONS: 'ANSWER_QUESTIONS',
  COMPREHENSIVE: 'COMPREHENSIVE',
}

// 习题类型枚举
export const EXERCISE_TYPE_ENUM = {
  NOEXERCISETYPE: 0,
  SINGLE_CHOICE: 1,
  MULTIPLE_CHOICE: 2,
  COMPLETION: 3,
  JUDGE: 4,
  ANSWER_QUESTIONS: 5,
  COMPREHENSIVE: 6,
}

// 习题类型名称枚举
export const EXERCISE_TYPE_NAME = {
  0: '无题型',
  1: '单选题',
  2: '多选题',
  3: '填空题',
  4: '判断题',
  5: '简答题',
  6: '综合题',
}

// 习题类型选择
export const EXERCISE_TYPE_OPTION = [
  {
    value: 'SINGLE_CHOICE',
    label: '单选题',
  },
  {
    value: 'MULTIPLE_CHOICE',
    label: '多选题',
  },
  {
    value: 'JUDGE',
    label: '判断题',
  },
  {
    value: 'COMPLETION',
    label: '填空题',
  },
  {
    value: 'ANSWER_QUESTIONS',
    label: '简答题',
  },
  {
    value: 'COMPREHENSIVE',
    label: '综合题',
  },
  {
    value: 'NOEXERCISETYPE',
    label: '无题型',
  },
]
